import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setAuthToken } from "../../utils/globalSlice";

//declare api endpoints based on env environment parameter
//change env value accordingly when deploying
let apiEndpoint = "";
if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  apiEndpoint = "https://stgcarsapi.fazaa.ae/api/";
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  apiEndpoint = "https://prdcarsapi.fazaa.ae/api/";
  // apiEndpoint = "https://stgcarsapi.fazaa.ae/api/";
}

const baseQuery = fetchBaseQuery({
  baseUrl: apiEndpoint,
  // prepareHeaders: (headers, { getState }) => {
  //   // Get the token from the state
  //   const token = getState().global.token;
  //   // If we have a token, set it in the headers
  //   if (token) {
  //     headers.set("Authorization", `Bearer ${token}`);
  //   }
  //   return headers;
  // },
});
export const apis = createApi({
  reducerPath: "apis",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    //api query to get token
    // getToken: builder.query({
    //   query: (credentials) => ({
    //     url: "/token",
    //     method: "GET",
    //     body: credentials,
    //   }),
    //   //sets token to state immedietly we get data from query response
    //   onQueryStarted: async (credentials, { dispatch, queryFulfilled }) => {
    //     try {
    //       const { data } = await queryFulfilled;
    //       dispatch(setAuthToken(data.token));
    //     } catch (error) {
    //       dispatch(setAuthToken(null));
    //     }
    //   },
    // }),
    //query to get all brands
    getAllBrands: builder.query({
      query: () => ({
        url: "/cars/usedCar/brand",
        method: "GET",
      }),
    }),

    //query to get all models
    getModels: builder.query({
      query: (brandId) => ({
        url: `/cars/model/${brandId}`,
        method: "GET",
      }),
    }),

    //query to get all status
    getAllStatus: builder.query({
      query: () => ({
        url: "/cars/status",
        method: "GET",
      }),
    }),
    //query to get all body types
    getAllBodyTypes: builder.query({
      query: () => ({
        url: "/cars/body",
        method: "GET",
      }),
    }),

    //query to get all cars to list
    getAllCars: builder.query({
      query: (payload) => ({
        url: `/cars/usedCar/listing?limit=${payload.limit}&offset=${payload.offset}`,
        method: "POST",
        body: payload.payloadData,
      }),
    }),

    //query to get single car by iid
    getCarById: builder.query({
      query: (payload) => ({
        url: "/cars/usedCar/view",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

//hooks for each query
export const {
  useGetAllBrandsQuery,
  useGetTokenQuery,
  useGetModelsQuery,
  useGetAllCarsQuery,
  useGetCarByIdQuery,
  useGetAllStatusQuery,
  useGetAllBodyTypesQuery,
} = apis;
